// src/components/PromoBanner.jsx
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  banner: {
    // Subtle diagonal gradient for more depth
    background: "linear-gradient(135deg, #4D4FB2 0%, #6A73C1 100%)",
    color: "#FFFFFF", // Change text to white for better contrast on gradient
    padding: theme.spacing(2),
    textAlign: "center",
    borderRadius: "8px",
    // Softer border, maybe slightly inset shadow for depth
    border: "1px solid rgba(255, 255, 255, 0.3)",
    boxShadow: "inset 0 1px 2px rgba(0,0,0,0.2), 0 2px 4px rgba(0,0,0,0.1)",
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(2.5), // Slightly adjust padding
    },
  },
  bannerText: {
    fontWeight: 500, // Slightly bolder
    textShadow: "0 1px 1px rgba(0, 0, 0, 0.3)", // More subtle text shadow
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.9rem", // Slightly larger on mobile
    },
  },
}));

function PromoBanner({ message }) {
  const classes = useStyles();

  return (
    <Box className={classes.banner}>
      <Typography variant="h6" className={classes.bannerText}>
        {message}
      </Typography>
    </Box>
  );
}

export default PromoBanner;
